<template>
  <div>
    <p class="mb-2">{{ $t('QUIZZES.LABEL.YOUR_ANSWER') }}:</p>
    <textarea
      class="form-control"
      id="dynamic-answer"
      :value="modelValue"
      @input="e => $emit('update:modelValue', e.target.value)"
      rows="5"
      max-rows="20"
      ref="textarea"
      v-dynamic-height="{ minHeight: '42px' }"
    >
    </textarea>
  </div>
</template>

<script lang="ts">
export default {
  name: 'QuizDynamicHeightComponent',
  props: {
    modelValue: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';
.form-control {
  resize: none;
}

.words-counter {
  display: flex;
  justify-content: flex-end;
}
</style>
